import { InjectionToken } from '@angular/core';
import { Environment } from './environment.base';

export { ENVIRONMENT } from './environment.local';
export { Environment } from './environment.base';

export const ENVIRONMENT_DI = new InjectionToken<Environment>(
  'Constant platform-specific compiled environment injection',
);
